var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    class: _vm.classes
  }, [(_vm.title) ? _c('legend', {
    staticClass: "Polaris-ChoiceList__Title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "Polaris-ChoiceList__Choices"
  }, _vm._l((_vm.choices), function(choice) {
    return _c('li', [(_vm.allowMultiple) ? _c('polaris-checkbox', {
      attrs: {
        "name": _vm.finalName,
        "value": choice.value,
        "label": choice.label,
        "helpText": choice.helpText,
        "disabled": _vm.disabled,
        "checked": _vm.choiceIsSelected(choice)
      },
      on: {
        "change": function($event) {
          _vm.handleChange($event, choice)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.allowMultiple) ? _c('polaris-radio-button', {
      attrs: {
        "name": _vm.finalName,
        "value": choice.value,
        "label": choice.label,
        "helpText": choice.helpText,
        "disabled": _vm.disabled,
        "checked": _vm.choiceIsSelected(choice)
      },
      on: {
        "change": function($event) {
          _vm.handleChange($event, choice)
        }
      }
    }) : _vm._e()], 1)
  }))])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b81ec704", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81ec704","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisChoiceList.vue
// module id = 251
// module chunks = 0